<template lang="pug">
.col-6
  .row
    .col-12
      h3 Сотрудники
        button.add_one(@click="$modal.show('new_user')")
          i.fal.fa-plus-circle(style="margin-right: 5px")
          | Добавить
    .col-6(v-for="e of employee")
      .employee
        .name 
          .online(:status="e.online")
          | {{ e.name }}
        .about(v-if="e.secret") Сотрудник заведения
        .about(v-if="e.token") Техническая учётка
        .about_manager(v-if="e.token") Для раздачи кодов.
        .secret(v-if="e.secret") 
          .timing(:style="`width: ${e.quick_key_timing}%`")
          | {{ e.secret_code }}
        button.styled.red.full_width(
          :disabled="e.removing",
          @click="removeEmployee(e)"
        ) Удалить
    modal.new_user(name="new_user", height="auto", :adaptive="true") 
      .close(@click="$modal.hide('new_user')")
        i.fal.fa-times
      .container
        .row
          .col
            h2 Создание нового пользователя
            .content
              .inputModule
              input-module(
                type="text",
                ref="new_user_name",
                title="Имя пользователя",
                v-model="new_user.name"
              ) 
              .inputModule
              input-module(
                type="select",
                title="Тип пользователя",
                v-model="new_user.type",
                :values="new_user.user_types",
                valueKey="id",
                valueName="name"
              ) 
              .alert(
                v-if="new_user.type == 20 && employee.find((x) => x.type == 20)"
              )
                b У Вас уже существует пользователь для раздачи кодов.
                br
                | Мы рекомендуем использовать одного пользователя на склад для раздачи кодов.
              .buttons
                button.styled.createLink(
                  :disabled="new_user.name == '' || new_user.loading || (new_user.type == 20 && employee.find((x) => x.type == 20))",
                  @click="createEmployee"
                ) Создать пользователя
</template>

<script>
import moment from "moment";
import swal from "sweetalert2";
import apiDriver from "../../../apiDriver";
let crypto = require("../crypto").default;

let copyObject = require("../copyObject").default;

export default {
  props: ["employee"],
  data() {
    return {
      timer_updateSecret: undefined,
      new_user: {
        name: "",
        type: "1",
        user_types: [
          { id: 1, name: "Сотрудник заведения" },
          { id: 20, name: "Раздатчик кодов" },
        ],
        loading: false,
      },
    };
  },
  methods: {
    async createEmployee() {
      this.new_user.loading = true;
      this.$toast.info("Создание пользователя...");
      let new_user = await apiDriver.services.api.post(
        "inventory",
        "employee/create",
        {
          name: this.new_user.name,
          store_id: this.$route.params.id,
          type: this.new_user.type,
        }
      );
      if (!new_user) {
        this.new_user.loading = false;
        this.$toast.error("Ошибка создания пользователя...");
        return;
      }
      new_user = new_user.data.employee;
      this.new_user.loading = false;
      this.new_user.name = "";
      this.$toast.success("Пользователь создан!");
      this.$modal.hide("new_user");
      new_user.removing = false;
      new_user.secret_code = "- --- ---";
      new_user.quick_key_timing = 0;
      this.$emit("Changed", {
        type: "create",
        new_data: new_user,
      });
      //   this.employee.push(new_user);
      console.log("new_user", new_user);
    },
    async removeEmployee(user) {
      swal({
        title: "Вы уверены?",
        text: "Удаляем пользователя " + user.name + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Да! Удаляй!",
        cancelButtonText: "Нет, стоп...",
      }).then(async (result) => {
        if (result) {
          user.removing = true;
          let removed = await apiDriver.services.api.post(
            "inventory",
            "employee/remove",
            { id: user.id }
          );
          if (!removed) {
            this.$toast.error("Ошибка удаления пользователя...");
            user.removing = false;
            return;
          }

          this.$emit("Changed", {
            type: "remove",
            employee_id: user.id,
          });
          //   this.employee = this.employee.filter((x) => x.id != user.id);
          this.$toast.success("Пользователь удален!");
        }
      });
    },
  },
  mounted() {
    console.log("warehouse employee component mounted");
    this.timer_updateSecret = setInterval(() => {
      let spice = this.employee.find((x) => x.token);
      if (!spice) return;
      spice = spice.token.match(/\d/g).join("");
      for (let e of this.employee) {
        if (!e.secret) continue;
        e.secret_code = crypto.code
          .makeSecret(spice, e.secret)
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        let seconds = moment().format("ss");
        e.quick_key_timing =
          100 -
          (((parseInt(seconds) + (seconds > 30 ? -30 : 0)) / 30) * 100).toFixed(
            2
          );
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer_updateSecret);
  },
};
</script>

<style lang="scss" scoped>
.employee {
  background: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  .name {
    font-size: 14pt;
    font-weight: bold;

    .online {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #eee;
      margin-right: 5px;
      border-radius: 20px;
      position: relative;
      top: -4px;

      &[status="1"] {
        background: #4caf50;
      }
    }
  }

  .secret {
    min-height: 20px;
    background: #eee;
    font-family: monospace;
    margin: 5px 0px;
    padding: 5px 10px;

    &:before {
      content: "QUICK KEY: ";
    }

    position: relative;
    overflow: hidden;
    border-radius: 4px;

    .timing {
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #3f51b5;
      transition: 0.3s all;
    }
  }

  .about {
    color: #a5a5a5;
    font-size: 9pt;
    margin-bottom: 10px;
  }

  .about_manager {
    min-height: 20px;
    background: #eee;
    font-family: monospace;
    margin: 5px 0px;
    padding: 5px 10px;
  }
}

.add_one {
  cursor: pointer;
  font-size: 12px;
  position: relative;
  top: -3px;
  padding: 0px 10px;
  opacity: 0.6;
  border: 1px solid black;
  border-radius: 20px;
  height: 27px;
  display: inline-block;
  line-height: normal;
  margin-left: 15px;
  outline: none;

  &:hover {
    opacity: 1;
  }
}
</style>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .employee {
    background: #161616;
  }

  .employee .about_manager {
    background: #343434;
  }

  .employee .secret {
    background: #343434;
  }

  .add_one {
    opacity: 0.9;
  }

  .employee .secret .timing {
    background: #5068ed;
  }
}
</style>
